/** Deliberately broken apparatus. */
export class Borked {
    render(appearance) {
        return {
            graphic: undefined,
            hitShape: undefined
        };
    }
}
Borked.properties = {
    label: "Borked",
    canContainLiquids: true,
    defaultAppearance: {},
    appearanceSpecs: [],
};
